// German locale
const locale = {
  common: {
    loading: "Wird geladen...",
    error: "Fehler: {{message}}",
    noDataFound: "Keine Daten gefunden",
    processing: "Wird verarbeitet...",
    search: "Suchen",
    actions: "Aktionen",
    save: "Speichern",
    saving: "Wird gespeichert...",
    update: "Aktualisieren",
    updating: "Wird aktualisiert...",
    cancel: "Abbrechen",
    edit: "Bearbeiten",
    delete: "Löschen",
    create: "Erstellen",
    submit: "Absenden",
    close: "Schließen",
    previous: "Zurück",
    next: "Weiter",
    page: "Seite {{current}} von {{total}}",
    confirmation: "Bestätigung",
    expand: "Erweitern",
    collapse: "Einklappen",
    yes: "Ja",
    no: "Nein",
    on: "An",
    off: "Aus",
    user: "Benutzer",
    errorObj: {
      fieldRequired: "Dieses Feld ist erforderlich",
      connectionError: "Verbindungsfehler",
      unknownError: "Unbekannter Fehler",
    },
    notSpecified: "Nicht angegeben",
    refresh: "Aktualisieren",
    filter: "Filtern",
    download: "Herunterladen",
    reportPassword:
      "Bitte geben Sie das Geburtsjahr des Benutzers ein, um den Bericht herunterzuladen",
  },
  calendar: {
    weekday0: "So",
    weekday1: "Mo",
    weekday2: "Di",
    weekday3: "Mi",
    weekday4: "Do",
    weekday5: "Fr",
    weekday6: "Sa",
    month0: "Januar",
    month1: "Februar",
    month2: "März",
    month3: "April",
    month4: "Mai",
    month5: "Juni",
    month6: "Juli",
    month7: "August",
    month8: "September",
    month9: "Oktober",
    month10: "November",
    month11: "Dezember",
  },
  languages: {
    english: "Englisch",
    german: "Deutsch",
  },
  profileSettings: {
    title: "Profileinstellungen",
    subtitle:
      "Aktualisieren Sie Ihre persönlichen Informationen und Präferenzen. Ihre Profildaten werden im gesamten System verwendet.",
    personalInfo: "Persönliche Informationen",
    firstName: "Vorname",
    lastName: "Nachname",
    email: "E-Mail-Adresse",
    emailNotEditable: "E-Mail-Adresse kann nicht geändert werden",
    mobile: "Mobil-/Telefonnummer",
    preferences: "Regionale Einstellungen",
    language: "Sprache",
    languageDescription:
      "Ihre bevorzugte Sprache für Benachrichtigungen und Benutzeroberfläche",
    timezone: "Zeitzone",
    cetTimezone: "Mitteleuropäische Zeit (MEZ)",
    timezoneDescription:
      "Wird für Terminplanung und zeitbasierte Benachrichtigungen verwendet",
    updateButton: "Profil aktualisieren",
    profileUpdated: "Profil aktualisiert",
    languageUpdated: "Sprache aktualisiert",
    notAvailable: "Profil nicht verfügbar",
    loginAgain:
      "Bitte melden Sie sich erneut an oder kontaktieren Sie einen Administrator, wenn das Problem weiterhin besteht.",
  },
  navigation: {
    dashboard: "Dashboard",
    teamEmployees: "Team / Mitarbeiter",
    labTestBookings: "Buchungen",
    pharmacySettings: "Apothekeneinstellungen",
    pharmacyDetails: "Apothekendetails",
    labTestAvailable: "Verfügbare Tests",
    schedules: "Öffnungszeiten",
    profileSettings: "Profileinstellungen",
    profile: "Profil",
    changePassword: "Passwort ändern",
    tutorials: "Dokumente",
    pharmacyAppointments: "Apotheken-Termine",
    logout: "Abmelden",
  },
  pharmacyAppointments: {
    title: "Apotheken-Termine",
    subtitle: "Verwalten Sie Ihre Termintypen und Kundenbuchungen",
    myAppointments: "Meine Termine",
    customerBookings: "Kundenbuchungen",
    createNewAppointment: "Neuen Termin erstellen",
    createFirstAppointment: "Erstellen Sie Ihren ersten Termintyp",
    searchAppointments: "Termine suchen...",
    searchBookings: "Buchungen suchen...",
    noAppointmentsFound: "Keine Termine gefunden, die Ihrer Suche entsprechen.",
    noAppointmentsYet: "Noch keine Termintypen erstellt.",
    noBookingsFound: "Keine Buchungen gefunden, die Ihren Filtern entsprechen.",
    noBookingsYet: "Keine Buchungen gefunden.",
    appointmentName: "Terminname",
    description: "Beschreibung",
    price: "Preis",
    discountEnabled: "Rabatt aktivieren",
    discountType: "Rabatttyp",
    discountValue: "Rabattwert",
    startDate: "Startdatum",
    endDate: "Enddatum",
    startTime: "Startzeit",
    endTime: "Endzeit",
    intervalMinutes: "Intervall (Minuten)",
    isRecurring: "Wiederkehrender Termin",
    recurringDays: "Wiederkehrende Tage",
    isActive: "Aktiv",
    visibleOnBookingPage: "Auf Buchungsseite sichtbar",
    visibleOnBookingPageHint:
      "Wenn deaktiviert, können Kunden diesen Termintyp online nicht buchen. Apothekenmitarbeiter können weiterhin für Nutzer buchen.",
    blockTestingSlots: "Testzeiten blockieren",
    blockTestingSlotsHint:
      "Wenn aktiviert, blockieren gebuchte Termine die Labortest-Zeitfenster im selben Raum. Deaktivieren, wenn dieser Termin einen anderen Raum nutzt.",
    staffOnly: "Nur für Mitarbeiter",
    hiddenFromCustomers: "Für Kunden ausgeblendet",
    statusSettings: "Status & Sichtbarkeit",
    available: "Verfügbar",
    hours: "Stunden",
    interval: "Intervall",
    recurring: "Wiederkehrend",
    status: "Status",
    active: "Aktiv",
    inactive: "Inaktiv",
    edit: "Bearbeiten",
    delete: "Löschen",
    markComplete: "Als abgeschlossen markieren",
    cancel: "Abbrechen",
    completed: "Abgeschlossen",
    cancelled: "Storniert",
    expired: "Abgelaufen",
    upcoming: "Bevorstehend",
    holiday: "Feiertag",
    closed: "Geschlossen",
    customer: "Kunde",
    appointment: "Termin",
    dateTime: "Datum & Zeit",
    actions: "Aktionen",
    userDetails: "Benutzerdaten",
    expand: "Erweitern",
    collapse: "Einklappen",
    previous: "Zurück",
    next: "Weiter",
    page: "Seite",
    of: "von",
    allStatuses: "Alle Status",
    allDates: "Alle Daten",
    today: "Heute",
    past: "Vergangen",
    future: "Zukunft",
    confirmDelete: "Sind Sie sicher, dass Sie diesen Termin löschen möchten?",
    cancelReason: "Bitte geben Sie einen Grund für die Stornierung an:",
    reason: "Grund",
    started: "Gestartet",
    completedAt: "Abgeschlossen",
    loading: "Wird geladen...",
    error: "Fehler",
    success: "Erfolg",
    percentage: "Prozent",
    flatAmount: "Pauschalbetrag",
    off: "Rabatt",
    minutes: "Minuten",
    sunday: "Sonntag",
    monday: "Montag",
    tuesday: "Dienstag",
    wednesday: "Mittwoch",
    thursday: "Donnerstag",
    friday: "Freitag",
    saturday: "Samstag",
    sun: "So",
    mon: "Mo",
    tue: "Di",
    wed: "Mi",
    thu: "Do",
    fri: "Fr",
    sat: "Sa",
    bookForUser: "Für Benutzer buchen",
    bookAppointment: "Termin buchen",
    selectUser: "Benutzer auswählen",
    enterUserDetails: "Benutzerdetails eingeben",
    userExists: "Benutzer existiert",
    newUser: "Neuer Benutzer",
    firstName: "Vorname",
    lastName: "Nachname",
    email: "E-Mail",
    mobile: "Mobil",
    dateOfBirth: "Geburtsdatum",
    gender: "Geschlecht",
    male: "Männlich",
    female: "Weiblich",
    other: "Andere",
    selectAppointment: "Termin auswählen",
    selectDate: "Datum auswählen",
    selectTime: "Zeit auswählen",
    availableSlots: "Verfügbare Zeitslots",
    bookingSummary: "Buchungsübersicht",
    totalPrice: "Gesamtpreis",
    confirmBooking: "Buchung bestätigen",
    doubleBookingConfirm:
      "Dieser Zeitslot ({{date}} um {{time}}) hat bereits {{count}} Buchung(en): {{names}}.\n\nMöchten Sie wirklich einen weiteren Termin in diesem Slot buchen?",
    doubleBookingWarning:
      "Dieser Zeitslot hat bereits {{count}} Buchung(en): {{names}}. Sie können fortfahren, es ist jedoch eine Bestätigung erforderlich.",
    bookingSuccess: "Termin erfolgreich gebucht!",
    bookingError: "Terminbuchung fehlgeschlagen",
    userNotFound: "Benutzer nicht gefunden",
    noAvailableSlots: "Keine verfügbaren Zeitslots für das ausgewählte Datum",
    pleaseSelectUser:
      "Bitte wählen Sie einen Benutzer aus oder geben Sie Benutzerdetails ein",
    pleaseSelectAppointment: "Bitte wählen Sie einen Termintyp aus",
    pleaseSelectDate: "Bitte wählen Sie ein Datum aus",
    pleaseSelectTime: "Bitte wählen Sie einen Zeitslot aus",
    loadingTimeSlots: "Verfügbare Zeitslots werden geladen…",
    noTimeSlotsAvailable: "Keine Zeitslots für dieses Datum verfügbar. Bitte anderes Datum wählen.",
    chooseFromSlots: "Aus verfügbaren Slots wählen",
    enterCustomTime: "Eigene Uhrzeit eingeben",
    customTimeHint:
      "Beliebige Uhrzeit eingeben (z. B. außerhalb der regulären Öffnungszeiten oder wenn keine Slots angezeigt werden).",
    customTimeInvalid: "Bitte geben Sie eine gültige Uhrzeit ein (HH:MM).",
    customTimeOutsideSlots:
      "Diese Uhrzeit ist nicht in den gelisteten Slots für dieses Datum. Sie können sie trotzdem als eigene Uhrzeit buchen.",
    customTimeBadge: "eigene Uhrzeit",
    useCustomTimeHint:
      "Keine Slots gelistet? Wechseln Sie zu „Eigene Uhrzeit eingeben“, um eine beliebige Zeit zu buchen.",
    bookStepAppointment: "Terminart",
    bookStepSchedule: "Datum & Uhrzeit",
    bookStepCustomer: "Kundendaten",
    morningLabel: "Vormittag",
    afternoonLabel: "Nachmittag",
    eveningLabel: "Abend",
    nightLabel: "Nacht",
    slotsAvailable: "{{count}} verfügbar",
    noSlotsInPeriod: "Keine Slots in diesem Zeitraum",
    selectedSchedule: "Ausgewählt",
    scheduleHint: "Datum wählen, dann Slot oder eigene Uhrzeit festlegen.",
    timeSlotsError: "Zeitslots konnten nicht geladen werden. Bitte erneut versuchen.",
    staffOnlyDateHint:
      "Nur für Mitarbeiter: Wählen Sie manuell ein zukünftiges Datum. Der öffentliche Kalender gilt ggf. nicht für diesen Termintyp.",
    staffBookingDateHint:
      "Wählen Sie ein beliebiges zukünftiges Datum. Verfügbare Zeiten werden vom Server geladen.",
    userDetailsRequired: "Benutzerdetails sind für neue Benutzer erforderlich",
    appointmentDetailsRequired: "Termindetails sind erforderlich",
    bookingDetailsRequired: "Buchungsdetails sind erforderlich",
    // Validation messages
    appointmentNameRequired: "Terminname ist erforderlich",
    descriptionRequired: "Beschreibung ist erforderlich",
    priceRequired: "Preis ist erforderlich",
    discountValueRequired: "Rabattwert ist erforderlich",
    discountPercentageLimit: "Prozentrabatt muss weniger als 100% betragen",
    startDateRequired: "Startdatum ist erforderlich",
    endDateRequired: "Enddatum ist erforderlich",
    endDateAfterStartDate: "Enddatum muss nach dem Startdatum liegen",
    startTimeRequired: "Startzeit ist erforderlich",
    endTimeRequired: "Endzeit ist erforderlich",
    endTimeAfterStartTime: "Endzeit muss nach der Startzeit liegen",
    recurringDaysRequired: "Bitte wählen Sie mindestens einen wiederkehrenden Tag aus",
    // Modal translations
    editAppointment: "Termin bearbeiten",
    discountSettings: "Rabatt-Einstellungen",
    recurringSettings: "Wiederkehrende Einstellungen",
    finalPrice: "Endpreis",
    updateAppointment: "Termin aktualisieren",
    createAppointment: "Termin erstellen",
    bookingsViewSplit: "Geteilt",
    bookingsViewList: "Nur Liste",
    bookingsViewCalendar: "Nur Kalender",
    bookingsLayoutLabel: "Ansicht",
    bookingsLayoutGroupLabel: "Layout der Buchungen",
    bookingsListTitle: "Buchungsliste",
    bookingsScheduleTitle: "Terminkalender",
    calendarRangeLabel: "Kalenderzeitraum",
    calendarRangeGroupLabel: "Kalenderperiode",
    calendarViewDay: "Tag",
    calendarViewWeek: "Woche",
    calendarViewMonth: "Monat",
    calendarPrevious: "Vorheriger Zeitraum",
    calendarNext: "Nächster Zeitraum",
    calendarNoBookingsDay: "Keine Buchungen",
    bookingsDateInputsLockedHint:
      "In geteilter oder Nur-Kalender-Ansicht folgt der Datumsbereich dem Kalender (zurück / weiter / heute). Wechseln Sie zu „Nur Liste“, um Daten manuell zu wählen.",
    bookingsCalendarTruncationHint:
      "Es werden bis zu {{limit}} Buchungen vom Server für diesen Zeitraum angezeigt; {{total}} entsprechen Ihren Filtern. Zeitraum oder Filter bei Bedarf einschränken.",
    bookingsRefreshing: "Buchungen werden aktualisiert …",
  },
  sidebar: {
    pharmacyUser: "Apothekenbenutzer",
    administrator: "Administrator",
    standardUser: "Standardbenutzer",
    selectPharmacy: "Apotheke auswählen",
    mainNavigation: "Hauptnavigation",
    version: "somaplus Apotheken-Dashboard v{{version}}",
  },
  bookings: {
    title: "Buchungen",
    createBooking: "Buchung erstellen",
    searchPlaceholder: "Nachname, E-Mail oder Test suchen...",
    selectDate: "Datum auswählen",
    serialNumber: "Nr.",
    fullName: "Vollständiger Name",
    email: "E-Mail",
    testName: "Testname",
    price: "Preis",
    bookingDateTime: "Buchungsdatum & -uhrzeit",
    startedTestAt: "Test gestartet am",
    finishedTestAt: "Test abgeschlossen am",
    status: "Status",
    noBookingsFound: "Keine Buchungen für die ausgewählten Kriterien gefunden",
    changeStatus: "Buchungsstatus ändern",
    statusTypes: {
      open: "Offen",
      started: "Gestartet",
      sentToLab: "An Labor gesendet",
      labRejected: "Vom Labor abgelehnt",
      finished: "Abgeschlossen",
      manuallyCancelled: "Manuell storniert",
      autoCancelled: "Automatisch storniert",
    },
    actions: {
      start: "Starten",
      finish: "Abschließen",
      reschedule: "Neu planen",
      cancel: "Stornieren",
      repeat: "Erneute Entnahme",
    },
    confirmCancel:
      'Sind Sie sicher, dass Sie die Buchung für "{{name}}" stornieren möchten?',
    patientInformation: "Patienteninformationen",
    name: "Name",
    gender: "Geschlecht",
    dateOfBirth: "Geburtsdatum",
    age: "Alter",
    totalPrice: "Gesamtpreis",
    incTax: "(inkl. MwSt.)",
    bookingDetails: "Buchungsdetails",
    selectedLabTests: "Ausgewählte Testparameter",
    startTest: "Test starten",
    startTestNow: "Test jetzt starten",
    barcodeLabel: "Code vom Barcode-Scanner",
    barcodePlaceholder: "Barcode scannen oder eingeben",
    repeatCollectionLabel: "Wiederholte Blutentnahme (kostenlos)",
    requiredDocuments: "Erforderliche Dokumentsignaturen",
    privacyPolicyConfirmation:
      "Ich bestätige, dass der Patient die Datenschutzerklärung unterschrieben hat.",
    disclaimerConfirmation:
      "Ich bestätige, dass der Patient den Haftungsausschluss unterschrieben hat.",
    consentFormConfirmation:
      "Ich bestätige, dass der Patient den Test bezahlt hat.",
    testStartedSuccess: "Test erfolgreich gestartet!",
    startDiscount: {
      enable: "Rabatt beim Start anwenden",
      percentage: "Prozent (%)",
      flat: "Fester Betrag (€)",
      preview: "Preis nach Rabatt: {{original}} → {{final}}",
      catalogDiscountApplied: "Katalogpreis war",
    },
    errorStartingBooking: "Fehler beim Starten der Buchung: {{error}}",
    cancelled: "Buchung storniert!",
    finishTest: "Test abschließen",
    barcode: "Barcode",
    clickToRevealBarcode: "Zum Anzeigen klicken",
    noBarcode: "Kein Barcode",
    statusOpen: "Offen",
    statusStarted: "Gestartet",
    statusCancelled: "Storniert",
    statusAutoCancelled: "Automatisch storniert",
    lastUpdated: "Zuletzt aktualisiert",
    topLabTestsUsed: "Am häufigsten verwendete Tests",
    bookingsByStatus: "Buchungen nach Status",
    unattendedBookings: "Unbearbeitete Buchungen",
    cancelledBookings: "Stornierte Buchungen",
    completedBookings: "Abgeschlossene Buchungen",
    bookingActivity: "Buchungsaktivität",
    allBookings: "Alle Buchungen",
    openBookings: "Offene Buchungen",
    pendingBookings: "Ausstehende Buchungen",
    performedTests: "Durchgeführte Tests",
    missed: "Verpasst",
    inProgress: "In Bearbeitung",
    extended: "Verlängert",
    overdue: "Überfällig",
    noTestsInProgress: "Keine Tests derzeit in Bearbeitung.",
    noManuallyCancelledBookings: "Keine manuell stornierten Buchungen.",
    noAutoCancelledBookings: "Keine automatisch stornierten Buchungen.",
    noBookingData: "Keine Buchungsdaten verfügbar.",
    reschedule: "Neu planen",
    view: "Ansehen",
    timeAndStatus: "Zeit & Status",
    duration: "Dauer",
    today: "Heute",
    yesterday: "Gestern",
    next2Days: "Nächste 2 Tage",
    last3Days: "Letzte 3 Tage",
    past: "Letzte {{period}} Tage",
    currentMonth: "Dieser Monat",
    pastMonth: "Letzter Monat",
    lastYear: "Letztes Jahr",
    thisYear: "Dieses Jahr",
    last5Years: "Letzte 5 Jahre",
    due: "Fällig in",
    lateBy: "Verspätet um",
    pharmacyDashboard: "Apotheken-Dashboard",
    adminDashboard: "Admin-Dashboard",
    viewStatisticsAndAnalytics:
      "Statistiken und Analysen für Ihre Apotheke anzeigen",
    totalBookingsVsRevenue: "Gesamtbuchungen vs. Umsatz",
    topLabTestsByBookingCount: "Top 3 Tests nach Buchungsanzahl",
    bookingCount: "Buchungsanzahl",
    bookingStatusBreakdown: "Buchungsstatus-Aufschlüsselung",
    countRevenue: "Anzahl / Umsatz",
    time: "Zeit",
    upcoming: "Anstehend",
    approaching: "Bevorstehend",
    error: "Fehler: {{message}}",
    checkBookings: "Buchungen prüfen",
    bookWalkIn: "Walk-In buchen",
    testsInProgress: "Tests in Bearbeitung",
    manuallyCancelledBookings: "Manuell stornierte Buchungen",
    autoCancelledBookings: "Automatisch stornierte Buchungen",
    manageBookingsForDate: "Buchungen und Tests verwalten für {{date}}",
    finishTestModal: {
      barcode: "Barcode",
      scanBarcode:
        "Barcode des Patienten scannen oder eingeben, um fortzufahren",
      cancel: "Abbrechen",
      next: "Weiter",
      validating: "Validiere...",
      bookingDetails: "Buchungsdetails",
      verifyPatient: "Patienteninformationen vor dem Fortfahren überprüfen",
      fullName: "Vollständiger Name",
      dateOfBirth: "Geburtsdatum",
      gender: "Geschlecht",
      email: "E-Mail",
      labTests: "Tests",
      back: "Zurück",
      testResults: "Testergebnisse",
      enterResults: "Geben Sie die Ergebnisse für jeden Testparameter ein",
      resultValue: "Ergebniswert",
      enterValue: "Wert eingeben",
      saving: "Speichere...",
      preview: "Vorschau",
      previewGenerating: "Vorschau-PDF wird erstellt…",
      previewReady: "Vorschau bereit — nicht gespeichert.",
      openPreview: "Vorschau-PDF öffnen",
      previewError: "Fehler beim Erstellen der Vorschau",
      completeTest: "Test abschließen",
      fillAllResults: "Bitte füllen Sie alle Testergebnisse aus",
      atLeastOneResult: "Bitte geben Sie mindestens ein Testergebnis ein",
      resultsSuccess: "Testergebnisse erfolgreich gespeichert",
      resultError: "Fehler beim Speichern der Testergebnisse",
      useCutoff: "Cutoff-Wert verwenden",
      testDetails: "Testdetails",
      referenceValues: "Referenzwerte",
      property: "Eigenschaft",
      value: "Wert",
      testId: "Test-ID",
      groupName: "Gruppenname",
      unitMeasuredIn: "Einheit gemessen in",
      rangeInputType: "Bereichseingabetyp",
      cutoffValue: "Cutoff-Wert",
      pairedRange1: "Gepaarter Bereich 1",
      pairedRange2: "Gepaarter Bereich 2",
      pairedRange3: "Gepaarter Bereich 3",
      pairedRange4: "Gepaarter Bereich 4",
      numberOfPairedRanges: "Anzahl gepaarter Bereiche",
      notSpecified: "Nicht angegeben",
      range: "Bereich",
      category: "Kategorie",
      explanation: "Erklärung",
      noReferenceData: "Keine Referenzdaten verfügbar",
      male: "Männlich",
      female: "Weiblich",
      both: "Beide",
      allAgeGroups: "Alle Altersgruppen",
      age: "Alter",
      reviewConfirm: "Prüfen & Bestätigen",
      reviewDescription: "Prüfen Sie die Ergebnisse unten, bevor Sie speichern. Der Test wird abgeschlossen und der Bericht erstellt.",
      missingResultsTitle: "Fehlende Ergebnisse",
      missingResultsDescription: "Die folgenden Werte wurden noch nicht eingegeben. Sie können zurückgehen, um sie auszufüllen, oder mit den vorhandenen Werten speichern.",
      missingCount: "{{count}} Wert(e) fehlen",
      noResultsEntered: "Keine Werte eingegeben",
      confirmSave: "Bestätigen & Speichern",
      editResults: "Ergebnisse bearbeiten",
      resultPreview: "Zu speichernde Ergebnisse",
      enteredValue: "Eingegebener Wert",
      referenceCategory: "Referenzkategorie",
      referenceMeaning: "Bedeutung",
      noReferenceMatch: "Kein passender Referenzbereich für diesen Wert",
      noReferenceAvailable: "Keine Referenzdaten — Wert wird wie eingegeben gespeichert",
      cutoffApplied: "Cutoff-Wert angewendet",
      usingCutoff: "Cutoff verwendet",
      outOfRange: "Außerhalb der Referenzbereiche",
      patientContext: "Patient: {{gender}}, Alter {{age}}",
      errorFlag: "Fehler",
      errorResultMessage:
        "Leider konnte der Test nicht ordnungsgemäß ausgewertet werden und muss wiederholt werden.",
    },
    rescheduleModal: {
      title: "Buchung neu planen",
      currentBooking: "Aktuelle Buchung",
      newBooking: "Neue Buchung",
      selectDate: "Datum auswählen",
      selectTime: "Zeit auswählen",
      fillAllFields: "Bitte wählen Sie sowohl Datum als auch Zeit aus",
      success: "Buchung erfolgreich neu geplant",
      error: "Fehler beim Neuplanen der Buchung: {{error}}",
      confirm: "Neuplanung bestätigen",
    },
    customerBookingsSchedule: "Buchungen",
    bookingsLayoutLabel: "Ansicht",
    bookingsLayoutGroupLabel: "Layout der Buchungen",
    bookingsViewSplit: "Geteilt",
    bookingsViewList: "Nur Liste",
    bookingsViewCalendar: "Nur Kalender",
    bookingsListTitle: "Buchungsliste",
    bookingsScheduleTitle: "Terminkalender",
    calendarRangeLabel: "Kalenderzeitraum",
    calendarRangeGroupLabel: "Kalenderperiode",
    calendarViewDay: "Tag",
    calendarViewWeek: "Woche",
    calendarViewMonth: "Monat",
    calendarPrevious: "Vorheriger Zeitraum",
    calendarNext: "Nächster Zeitraum",
    calendarNoBookingsDay: "Keine Buchungen",
    bookingsDateInputsLockedHint:
      "In geteilter oder Nur-Kalender-Ansicht steuert der Kalender (zurück / heute / weiter) den Zeitraum. Wechseln Sie zu „Nur Liste“, um den Datumsbereich-Wähler zu nutzen.",
    bookingsRefreshing: "Buchungen werden aktualisiert …",
    downloadReport: "Buchungsbericht herunterladen",
    appointmentDetailsTitle: "Termindetails",
    blockTimeTitle: "Zeit blockieren",
    editBlockedTimeTitle: "Blockierte Zeit bearbeiten",
    cancellationReasonLabel: "Stornierungsgrund:",
    markComplete: "Als abgeschlossen markieren",
    cancelAppointment: "Termin stornieren",
    statusUpdated: "Status erfolgreich aktualisiert",
    bookingCancelled: "Buchung erfolgreich storniert",
    failedUpdateStatus: "Fehler beim Aktualisieren des Status",
    failedCancelBooking: "Fehler beim Stornieren der Buchung",
    appointmentName: "Name:",
    appointmentPrice: "Preis:",
    blockEntireDay: "Gesamten Tag blockieren?",
    blockFromTime: "Blockieren ab",
    blockUntilTime: "Blockieren bis",
    blockTimeRequired: "Start- und Endzeit sind für Teilblockierungen erforderlich.",
    closedFullDay: "Ganztägig geschlossen",
    partialDayBlocked: "Teilweise blockiert",
    partialDayBlockedRange: "Blockiert {{from}}–{{to}}",
    openingTime: "Öffnungszeit",
    closingTime: "Schließzeit",
    descriptionReason: "Beschreibung / Grund",
    saveBlock: "Blockierung speichern",
    updateBlock: "Blockierung aktualisieren",
    deleteBlock: "Blockierung löschen",
    confirmDeleteBlock: "Sind Sie sicher, dass Sie diese Blockierung löschen möchten?",
    blockSaved: "Zeit erfolgreich blockiert",
    blockUpdated: "Blockierung erfolgreich aktualisiert",
    blockDeleted: "Blockierung erfolgreich gelöscht",
    blockFailed: "Fehler beim Speichern der Blockierung",
  },
  bookingForm: {
    addNewBooking: "Neue Buchung hinzufügen",
    selectUser: "E-Mail eingeben",
    userDetails: "Benutzerdetails",
    newUserDetails: "Neue Benutzerdetails",
    searchUserPlaceholder:
      "Tippen Sie, um zu suchen oder einen Benutzer zu erstellen",
    firstName: "Vorname",
    lastName: "Nachname",
    dateOfBirth: "Geburtsdatum",
    gender: "Geschlecht",
    selectGender: "Geschlecht auswählen",
    male: "Männlich",
    female: "Weiblich",
    postalCode: "Postleitzahl",
    phoneNumber: "Telefonnummer",
    selectLabTest: "Testparameter auswählen",
    searchLabTestPlaceholder: "Suchen und Test auswählen",
    totalPrice: "Gesamtpreis",
    originalPrice: "Ursprünglicher Preis",
    applyDiscount: "Rabatt anwenden",
    applyDiscountHint:
      "Optionaler Rabatt zusätzlich zu Katalogpreisen. Wird in der Buchung für Auswertungen gespeichert.",
    selectDateTime: "Datum und Uhrzeit auswählen",
    calendarUpdatesDateTime:
      "Aktualisiert Datum und Uhrzeit oben — wählen Sie unten ein Datum und eine Uhrzeit.",
    selectDateTitle: "Datum auswählen",
    selectTimeTitle: "Uhrzeit auswählen",
    selectDateHint:
      "Wählen Sie ein Datum, um verfügbare Zeitslots zu sehen.",
    pastDateNoSlots:
      "Für vergangene Daten werden keine Zeitslots angezeigt. Bitte wählen Sie heute oder ein zukünftiges Datum.",
    morningLabel: "Vormittag",
    afternoonLabel: "Nachmittag",
    eveningLabel: "Abend",
    slotsLabel: "Slots",
    noSlotsLabel: "Keine Slots verfügbar",
    calendarConnectedToDateTime:
      "Wie Datum und Uhrzeit oben — Datum und Uhrzeit hier auswählen.",
    showCalendar: "Kalender anzeigen",
    startTestNow: "Test jetzt starten?",
    codeFromBarcodeScanner: "Barcode",
    reviewBookingDetails: "Buchungsdetails prüfen",
    editDetails: "Details bearbeiten",
    saveBooking: "Buchung speichern",
    saving: "Wird gespeichert...",
    bookingSummary: "Buchungsübersicht",
    name: "Name",
    age: "Alter",
    appointment: "Termin",
    selectedLabTests: "Ausgewählte Testparameter",
    notSpecified: "Nicht angegeben",
    staffBooking: "Mitarbeiter-Buchung",
    staffBookingLabel: "Dies ist eine Mitarbeiter-Buchung",
    staffBookingHint:
      "Für Apothekenteam-Mitglieder. Patienteneinwilligung ist beim Teststart nicht erforderlich.",
    repeatCollectionLabel: "Wiederholte Blutentnahme",
    repeatCollectionHint:
      "Eine zweite Probe nach einem abgelehnten Labortest. Für diese Entnahme fallen keine Kosten an.",
    incTax: "inkl. MwSt.",
    errors: {
      selectLabTest: "Bitte wählen Sie einen Test aus.",
      fillUserDetails: "Bitte füllen Sie alle Benutzerdetails aus.",
    },
    labTestBookingDetailsTitle: "Lab Test Buchungsdetails",
    testDetails: "Testdetails",
    testsLabel: "Tests:",
    emailSent: "E-Mail erfolgreich gesendet",
    failedSendEmail: "Fehler beim Senden der E-Mail",
    editPatientDetails: "Patientendaten bearbeiten",
    resendEmail: "E-Mail erneut senden",
  },
  labTests: {
    title: "Testparameter",
    addNew: "Neu hinzufügen",
    editTest: "Test bearbeiten",
    searchPlaceholder: "Nach Test suchen...",
    serialNumber: "Nr.",
    labTestName: "Testname",
    price: "Preis",
    discountedPrice: "Rabattpreis",
    status: "Status",
    statusActive: "Aktiv",
    statusInactive: "Inaktiv",
    addedOn: "Hinzugefügt am",
    totalRecords: "Gesamtanzahl",
    confirmDelete: 'Sind Sie sicher, dass Sie "{{name}}" löschen möchten?',
    discountTooltip: "Rabattpreis = Originalpreis × Rabattprozentsatz",
    modal: {
      selectTest: "Test auswählen",
      searchAndSelectTest: "Suchen und Test auswählen",
      pleaseSelectTest: "Bitte wählen Sie einen Test aus.",
      setPrice: "Preis festlegen (€ - inkl. MwSt.)",
      setCustomPrice: "Individuellen Preis festlegen (€ - inkl. MwSt.)",
      enterPrice: "Preis eingeben",
      enterCustomPrice: "Individuellen Preis eingeben",
      priceRequired: "Preis ist erforderlich!",
      testAddedSuccess: "Test '{{name}}' erfolgreich hinzugefügt!",
      testUpdatedSuccess: 'Test "{{name}}" erfolgreich aktualisiert!',
      enableDiscount: "Rabatt aktivieren",
      discountType: "Rabatttyp",
      percentage: "Prozentsatz",
      discountedPrice: "Rabattpreis",
      discountPercentage: "Rabattprozentsatz",
      enterDiscountPercentage: "Rabattprozentsatz eingeben (0-100)",
      enterDiscountedPrice: "Rabattpreis eingeben",
      discountPercentageRequired:
        "Rabattprozentsatz ist erforderlich und muss zwischen 0-100 liegen!",
      discountedPriceRequired:
        "Rabattpreis ist erforderlich und muss unter dem Originalpreis liegen!",
      calculatedPrice: "Berechneter Preis",
      calculatedPercentage: "Berechneter Prozentsatz",
      discountCalculation: "Rabattberechnung",
      originalPrice: "Originalpreis",
      discountAmount: "Rabattbetrag",
      finalPrice: "Endpreis",
    },
  },
  pharmacySettings: {
    title: "Apothekendetails",
    description:
      "Geben Sie die grundlegenden Informationen über Ihre Apotheke ein, die den Kunden angezeigt werden.",
    directBookingLinks: "Direkte Buchungslinks",
    directBookingDescription:
      "Verwenden Sie diese Links, damit Kunden direkt bei Ihrer Apotheke buchen können.",
    walkInLinks: "Walk-In URL",
    walkInDescription:
      "Verwenden Sie diese Links für Walk-In Buchungen in Ihrer Apotheke.",
    walkInEnabled: "Walk-In URL aktivieren",
    englishWalkInURL: "Englischer Walk-In URL",
    germanWalkInURL: "Deutscher Walk-In URL",
    englishURL: "Englischer Buchungs-URL",
    germanURL: "Deutscher Buchungs-URL",
    copyToClipboard: "URL kopieren",
    pharmacyDetails: "Apothekendetails",
    pharmacyName: "Name der Apotheke",
    mobilePhone: "Mobil- / Telefonnummer",
    address: "Adresse",
    addressDescription:
      "Geben Sie die physische Adresse Ihrer Apotheke für Kundenreferenz und Versand ein.",
    houseNumber: "Hausnummer",
    street: "Straße",
    postalCode: "Postleitzahl",
    city: "Stadt",
    state: "Bundesland",
    country: "Land",
    taxDetails: "Steuerdetails",
    taxDescription:
      "Geben Sie die Steuerinformationen Ihrer Apotheke für Rechnungsstellung und behördliche Zwecke ein.",
    taxInfo:
      "Diese Informationen werden für Steuerdokumente und Berichte verwendet.",
    vatId: "USt-IdNr.",
    updatePharmacyDetails: "Apothekendetails aktualisieren",
    updating: "Wird aktualisiert...",
    noPharmacyDetails: "Keine Apothekendetails verfügbar",
    contactAdmin:
      "Bitte kontaktieren Sie einen Administrator, um Ihre Apothekendetails einzurichten",
    isPubliclyListable: "In öffentlicher Liste auffindbar",
  },
  dashboard: {
    title: "Dashboard",
    selectDate: "Datum auswählen",
    selectDateRange: "Datumsbereich auswählen",
    switchToAdminView: "Zur Admin-Ansicht wechseln",
    switchToTeamView: "Zur Team-Ansicht wechseln",
    refreshData: "Daten aktualisieren",
    totalBooking: "Gesamtbuchungen",
    totalRevenue: "Gesamtumsatz",
    totalPatients: "Gesamtzahl der Patienten",
    bookingsCreated: "Buchungen erstellt",
    bookingsStarted: "Buchungen gestartet",
    bookingsFinished: "Buchungen abgeschlossen",
    bookingsCancelled: "Buchungen storniert",
    noUpcomingBookings: "Keine anstehenden Buchungen",
    upcomingBookings: "Anstehende Buchungen",
    dashboardStartTest: "Test starten",
    retryTest: "Test wiederholen",
    finishTest: "Ergebnis eintragen",
    noBookingsFound: "Keine Buchungen mit Status gefunden: {{status}}",
    statusOpen: "Offen",
    statusStarted: "Gestartet",
    statusFinished: "Abgeschlossen",
    statusManualCancelled: "Manuell storniert",
    statusAutoCancelled: "Automatisch storniert",
    lastUpdated: "Zuletzt aktualisiert",
    topLabTestsUsed: "Am häufigsten verwendete Tests",
    bookingsByStatus: "Buchungen nach Status",
    unattendedBookings: "Unbearbeitete Buchungen",
    cancelledBookings: "Stornierte Buchungen",
    completedBookings: "Abgeschlossene Buchungen",
    bookingActivity: "Buchungsaktivität",
    allBookings: "Alle Buchungen",
    openBookings: "Offene Buchungen",
    pendingBookings: "Ausstehende Buchungen",
    performedTests: "Durchgeführte Tests",
    missed: "Verpasst",
    inProgress: "In Bearbeitung",
    extended: "Verlängert",
    overdue: "Überfällig",
    cancelled: "Storniert",
    noTestsInProgress: "Keine Tests derzeit in Bearbeitung.",
    noManuallyCancelledBookings: "Keine manuell stornierten Buchungen.",
    noAutoCancelledBookings: "Keine automatisch stornierten Buchungen.",
    noBookingData: "Keine Buchungsdaten verfügbar.",
    reschedule: "Neu planen",
    view: "Ansehen",
    patientInformation: "Patienteninformationen",
    timeAndStatus: "Zeit & Status",
    duration: "Dauer",
    today: "Heute",
    yesterday: "Gestern",
    next2Days: "Nächste 2 Tage",
    last3Days: "Letzte 3 Tage",
    past: "Letzte {{period}} Tage",
    currentMonth: "Dieser Monat",
    pastMonth: "Letzter Monat",
    lastYear: "Letztes Jahr",
    thisYear: "Dieses Jahr",
    last5Years: "Letzte 5 Jahre",
    due: "Fällig in",
    lateBy: "Verspätet um",
    pharmacyDashboard: "Apotheken-Dashboard",
    adminDashboard: "Admin-Dashboard",
    viewStatisticsAndAnalytics:
      "Statistiken und Analysen für Ihre Apotheke anzeigen",
    totalBookingsVsRevenue: "Gesamtbuchungen vs. Umsatz",
    topLabTestsByBookingCount: "Top 3 Tests nach Buchungsanzahl",
    bookingCount: "Buchungsanzahl",
    bookingStatusBreakdown: "Buchungsstatus-Aufschlüsselung",
    countRevenue: "Anzahl / Umsatz",
    time: "Zeit",
    upcoming: "Anstehend",
    approaching: "Bevorstehend",
    error: "Fehler: {{message}}",
    checkBookings: "Buchungen prüfen",
    bookWalkIn: "Walk-In buchen",
    testsInProgress: "Tests in Bearbeitung",
    manuallyCancelledBookings: "Manuell stornierte Buchungen",
    autoCancelledBookings: "Automatisch stornierte Buchungen",
    manageBookingsForDate: "Buchungen und Tests verwalten für {{date}}",
  },
  leaderboard: {
    badge: "Leistung",
    title: "Apotheken-Rangliste",
    subtitle:
      "Sehen Sie, wie Ihre Apotheke bei abgeschlossenen Tests abschneidet. Andere Apotheken bleiben anonym.",
    thisMonth: "Dieser Monat",
    lastMonth: "Letzter Monat",
    thisWeek: "Diese Woche",
    lastWeek: "Letzte Woche",
    periodRange: "{{start}} bis {{end}}",
    rank: "Platz",
    pharmacy: "Apotheke",
    tests: "Tests",
    yourPharmacy: "Ihre Apotheke",
    anonymousPharmacy: "Apotheke auf Platz {{rank}}",
    yourRank: "Ihr aktueller Platz",
    outOfPharmacies: "Von {{total}} Apotheken",
    testsCompleted: "{{count}} Tests abgeschlossen",
    inTopTenSummary:
      "Sie sind auf Platz #{{rank}} mit {{count}} Tests von {{total}} Apotheken.",
    networkTrends: "Top-Tests im Netzwerk",
    yourTrends: "Ihre Top-Tests",
    noTrendData: "Noch keine Netzwerk-Trends für diesen Zeitraum.",
    noYourTrendData:
      "Noch keine abgeschlossenen Tests für Ihre Apotheke in diesem Zeitraum.",
    noData: "Noch keine Ranglistendaten für diesen Zeitraum.",
    expand: "Aufklappen",
    collapse: "Einklappen",
    collapsedHint: "Tippen für Details",
    collapsedRank: "Platz #{{rank}}",
    collapsedEmpty:
      "Schließen Sie Tests in diesem Zeitraum ab, um in der Rangliste zu erscheinen.",
    loadingSummary: "Platz wird geladen…",
    inTopTenBadge: "Top 10",
    topTestShort: "Top: {{name}} ({{count}})",
  },
  days: {
    monday: "Montag",
    tuesday: "Dienstag",
    wednesday: "Mittwoch",
    thursday: "Donnerstag",
    friday: "Freitag",
    saturday: "Samstag",
    sunday: "Sonntag",
  },
  scheduleSettings: {
    calendarConnection: "Kalenderverbindung",
    calendarConnectionDesc:
      "Verbinden Sie Ihren Kalender, um die Verfügbarkeit der Apotheke mit Ihrem externen Kalendersystem zu synchronisieren.",
    connectCalendar: "Kalender verbinden",
    connecting: "Verbinde...",
    calendarConnected: "Kalender verbunden",
    connectedCalendar: "Verbundener Kalender",
    disconnect: "Trennen",
    disconnecting: "Trennen...",
    calendarName: "Kalendername",
    timeZone: "Zeitzone",
    syncStatus: "Synchronisierungsstatus",
    synced: "Synchronisiert",
    notSynced: "Nicht synchronisiert",
    noCalendarConnected:
      "Noch kein Kalender verbunden. Bitte verbinden Sie einen Kalender.",
    connectingCalendar: "Verbindung zum Kalender wird hergestellt...",
    pharmacyIdNotFound: "Apotheken-ID nicht gefunden",
    calendarConnectionFailed: "Verbindung zum Kalender fehlgeschlagen",
    calendarDisconnected: "Kalender erfolgreich getrennt!",
    disconnectFailed: "Trennen des Kalenders fehlgeschlagen",
    refreshingCalendarData: "Kalenderdaten werden aktualisiert...",
    calendarDataRefreshed: "Kalenderdaten aktualisiert",
    refreshFailed: "Aktualisierung der Kalenderdaten fehlgeschlagen",
    loadingCalendarDetails: "Kalenderdaten werden geladen...",
    noCalendarIdProvided: "Keine Kalender-ID angegeben",

    weeklyHours: "Wochenöffnungszeiten",
    openingDays: "Öffnungszeiten",
    openingDaysDesc:
      "Legen Sie die regulären Öffnungszeiten Ihrer Apotheke für jeden Wochentag fest.",
    openingTime: "Geöffnet ab",
    closingTime: "Geöffnet bis",
    removeTimeSlot: "Zeitfenster entfernen",
    addAnotherTimeSlot: "Weiteres Zeitfenster hinzufügen",

    businesshoursonlyforview: "Geschäftszeiten nur zur Ansicht",
    businesshoursonlyforviewDisclaimer:
      "Wenn AN: Diese Zeiten werden nur zur Anzeige von Öffnungs- und Schließzeiten verwendet. Wenn AUS: Diese Zeiten werden zur Erstellung von Terminslots verwendet.",

    openingHoursForAppointments: "Öffnungszeiten für Termine",
    openingHoursForAppointmentsDesc:
      "Legen Sie spezifische Öffnungszeiten für Terminbuchungen fest. Diese können sich von Ihren allgemeinen Geschäftszeiten unterscheiden.",

    bookingSettings: "Buchungseinstellungen",
    bookingSettingsDesc:
      "Konfigurieren Sie, wie Kunden Termine mit Ihrer Apotheke buchen können.",
    timeSlotInterval: "Zeitfenster-Intervall",
    timeSlotIntervalDesc:
      "Dies bestimmt, wie Terminslots über Ihre Öffnungszeiten verteilt werden.",
    minutes: "{{count}} Minuten",

    holidaySettings: "Tag für Buchungen sperren",
    holidaySettingsDesc:
      "Legen Sie Tage fest, an denen Ihre Apotheke bspw. wegen Feiertagen geschlossen sein wird.",
    addHoliday: "Datum hinzufügen",
    selectHolidays:
      "Wählen Sie Daten aus, an denen Ihre Apotheke geschlossen sein wird.",
    scheduledHolidays: "Gesperrte Daten",
    removeHoliday: "Datum entfernen",

    schedulePatterns: "Zeitplanmuster",
    schedulePatternsDesc:
      "Richten Sie spezielle Zeitplanregeln ein, die bestimmten Mustern oder benutzerdefinierten Regeln folgen.",
    addSchedulePattern: "Zeitplanmuster hinzufügen",
    editSchedulePattern: "Zeitplanmuster bearbeiten",

    patternType: "Mustertyp",
    dayOfWeek: "Wochentag",
    startDate: "Startdatum",
    patternStartDateDesc: "Das Datum, ab dem dieses Muster angewendet wird.",
    defaultSetting: "Standardeinstellung",
    alternateWeekly: "Wöchentlich abwechselnd",
    customPattern: "Benutzerdefiniertes Muster",
    alternateWeeklyDesc:
      "Die Apotheke wird jede zweite Woche an diesem Tag geöffnet sein.",
    customPatternDesc:
      "Definieren Sie benutzerdefinierte Regeln für bestimmte Daten dieses Wochentags.",
    startingFrom: "Ab",
    open: "Geöffnet",
    closed: "Geschlossen",
    hours: "Öffnungszeiten",
    specificDates: "Bestimmte Daten",
    date: "Datum",
    status: "Status",
    addSpecificDate: "Bestimmtes Datum hinzufügen",
    noSpecificDates: "Keine bestimmten Daten definiert",
    noPatterns: "Keine Zeitplanmuster definiert",
    holidays: "Feiertage",

    editHoliday: "Feiertag bearbeiten",
    description: "Beschreibung",
    holidayDescription: "z.B. Weihnachten, gesetzlicher Feiertag",
    descriptionHelp:
      "Optionale Beschreibung oder Grund für den Feiertag/die Schließung",
    addHours: "Öffnungszeiten hinzufügen",
    noHoursSet: "Keine Öffnungszeiten festgelegt",

    updating: "Aktualisierung...",
    updateSchedule: "Zeitplan aktualisieren",
    notificationUpdated: "Apothekenzeitplan aktualisiert",
  },
  auth: {
    signIn: "Anmelden",
    signOut: "Abmelden",
    signUp: "Registrieren",
    forgotPassword: "Passwort vergessen",
    resetPassword: "Passwort zurücksetzen",
    enterEmail: "Geben Sie Ihre E-Mail-Adresse ein",
    enterPassword: "Geben Sie Ihr Passwort ein",
    rememberMe: "Angemeldet bleiben",
    submit: "Absenden",
    createAccount: "Konto erstellen",
    alreadyHaveAccount: "Haben Sie bereits ein Konto?",
    dontHaveAccount: "Haben Sie kein Konto?",
    loginInstead: "Stattdessen anmelden",
    passwordResetLink:
      "Link zum Zurücksetzen des Passworts an Ihre E-Mail gesendet",
    passwordResetSuccess: "Passwort erfolgreich zurückgesetzt",
    loginOrSignup: "Anmelden oder Registrieren",
    pharmacyDashboardTitle: "Apotheken-Dashboard - Testbuchung & Analytik",
    validation: {
      emailRequired: "E-Mail-Adresse ist erforderlich!",
      passwordRequired: "Passwort ist erforderlich!",
    },
    loggingIn: "Anmeldung läuft...",
    features: {
      labBooking: "Buchungsverwaltung",
      labBookingDesc: "mit Echtzeit-Terminplanung",
      reports: "Berichts-Uploads",
      reportsDesc: "für sichere Speicherung und einfachen Zugriff",
      analytics: "Erweiterte Analytik",
      analyticsDesc: "für Benutzeraktivität, Buchungstrends und Testergebnisse",
      calendar: "Kalenderansicht",
      calendarDesc:
        "zur einfachen Verfolgung von Testbuchungen und Verfügbarkeit",
      interface: "Benutzerfreundliche Oberfläche",
      interfaceDesc:
        "mit Fokus auf Benutzerfreundlichkeit und effizientem Arbeitsablauf",
    },
  },
  changePassword: {
    title: "Passwort ändern",
    description:
      "Aktualisieren Sie Ihr Passwort, um die Kontosicherheit zu gewährleisten. Wir empfehlen ein starkes, eindeutiges Passwort, das Sie nirgendwo sonst verwenden.",
    passwordSecurity: "Passwortsicherheit",
    currentPassword: "Aktuelles Passwort",
    newPassword: "Neues Passwort",
    confirmPassword: "Neues Passwort bestätigen",
    currentPasswordRequired: "Das aktuelle Passwort ist erforderlich!",
    newPasswordLength: "Das neue Passwort muss mindestens 6 Zeichen lang sein!",
    passwordsDoNotMatch: "Die Passwörter stimmen nicht überein!",
    hidePassword: "Passwort verbergen",
    showPassword: "Passwort anzeigen",
    passwordStrength: "Passwortstärke",
    requirements: {
      minLength: "Mindestens 8 Zeichen",
      uppercase: "Enthält Großbuchstaben",
      numbers: "Enthält Zahlen",
      special: "Enthält Sonderzeichen",
    },
    passwordsMatch: "Passwörter stimmen überein",
    passwordsDontMatch: "Passwörter stimmen nicht überein",
    updatePassword: "Passwort aktualisieren",
    updatingPassword: "Passwort wird aktualisiert...",
    passwordUpdatedSuccess: "Passwort erfolgreich aktualisiert",
  },
  passwordStrength: {
    veryWeak: "Sehr schwach",
    weak: "Schwach",
    medium: "Mittel",
    strong: "Stark",
    veryStrong: "Sehr stark",
  },
  team: {
    title: "Teammitglieder",
    teamEmployees: "Team / Mitarbeiter",
    addNewTeamMember: "Neues Teammitglied / Mitarbeiter hinzufügen",
    addNew: "Neu hinzufügen",
    name: "Name",
    emailId: "E-Mail-Adresse",
    mobile: "Mobiltelefon",
    role: "Rolle",
    status: "Status",
    roleTeam: "Team",
    roleUser: "Benutzer",
    statusActive: "Aktiv",
    statusInactive: "Inaktiv",
    accessDenied:
      "Sie können die Mitgliederdetails nicht einsehen. Zugriff verweigert",
    avatarAlt: "Avatar",
    deleteConfirmation:
      '"{{name}}" von dieser Apotheke entfernen? Wenn das Mitglied anderen Apotheken zugeordnet ist, bleibt das Konto dort aktiv.',
    validation: {
      firstNameRequired: "Vorname ist erforderlich!",
      emailRequired: "E-Mail-Adresse ist erforderlich!",
      passwordRequired: "Passwort ist für neue Teammitglieder erforderlich!",
      removeFailed:
        "Fehler beim Entfernen des Teammitglieds. Bitte versuchen Sie es erneut.",
      updateFailed:
        "Fehler beim Bearbeiten des Teammitglieds. Bitte versuchen Sie es erneut.",
      addFailed:
        "Fehler beim Hinzufügen des Teammitglieds. Bitte versuchen Sie es erneut.",
    },
    notifications: {
      memberAdded: "Neues Teammitglied erfolgreich hinzugefügt!",
      memberUpdated: "Teammitglied erfolgreich aktualisiert!",
    },
    form: {
      firstName: "Vorname",
      lastName: "Nachname",
      email: "E-Mail-Adresse",
      mobile: "Mobiltelefon / Telefonnummer",
      password: "Passwort",
      passwordPlaceholder: "Passwort eingeben",
      passwordOptionalHint:
        "Erforderlich für neue Mitglieder. Leer lassen, wenn ein bestehendes Teammitglied dieser Apotheke hinzugefügt wird.",
      generateRandomPassword: "Zufälliges Passwort generieren",
    },
    memberDeleted: "Mitglied gelöscht!",
    memberRemovedFromPharmacy: "Teammitglied von dieser Apotheke entfernt.",
    memberDeletedFully: "Teammitglied entfernt und Konto deaktiviert.",
  },
  transactions: {
    title: "Transaktionen",
    removeFilter: "Filter entfernen",
    name: "Name",
    emailId: "E-Mail-Adresse",
    location: "Standort",
    amount: "Betrag",
    transactionDate: "Transaktionsdatum",
    totalRecords: "Gesamtanzahl",
    searchPlaceholder: "Suche nach Name, E-Mail...",
  },
  tutorials: {
    title: "Dokumente",
    description:
      "Lernen Sie, wie Sie das Apotheken-Dashboard mit Schritt-für-Schritt-Dokumenten und Anleitungen verwenden.",
    comingSoon: "Dokumente kommen bald",
    comingSoonDescription:
      "Wir arbeiten daran, umfassende Dokumente zu erstellen, die Ihnen helfen, das Beste aus dem Apotheken-Dashboard herauszuholen. Schauen Sie bald wieder vorbei!",
    viewingAdminDashboard: "Sie sehen derzeit das Admin-Dashboard",
    viewingTeamDashboard: "Sie sehen derzeit das Team-Dashboard",
    adminDashboardDescription:
      "Als Administrator haben Sie Zugriff auf umfassende Analysen, Benutzerverwaltung und systemweite Einstellungen.",
    teamDashboardDescription:
      "Diese Ansicht bietet Zugriff auf den Tagesbetrieb, Buchungsverwaltung und team-spezifische Funktionen.",
    adminTutorials: "Admin-Dokumente",
    adminTutorialsDescription:
      "Umfassende Dokumente für Administratoren zu Systemverwaltung, Benutzeradministration und erweiterten Funktionen.",
    teamTutorials: "Team-Dokumente",
    teamTutorialsDescription:
      "Wesentliche Dokumente für Teammitglieder zu Tagesbetrieb, Buchungsverwaltung und grundlegenden Funktionen.",
    name: "Name",
    view: "Ansehen",
    download: "Herunterladen",
    actions: "Aktionen",
    sampleTutorial1: "Benutzerverwaltungsanleitung",
    sampleDescription1:
      "Lernen Sie, wie Sie Benutzer, Rollen und Berechtigungen im System verwalten.",
    sampleTutorial2: "Analysen & Berichte",
    sampleDescription2:
      "Verstehen Sie, wie Sie Berichte erstellen und Apothekendaten analysieren.",
    sampleTutorial3: "Buchungsverwaltung",
    sampleDescription3:
      "Schritt-für-Schritt-Anleitung zur Verwaltung von Testbuchungen und Terminen.",
    sampleTutorial4: "Tagesbetrieb",
    sampleDescription4:
      "Wesentliche Verfahren für den täglichen Apothekenbetrieb und Arbeitsabläufe.",
    createTutorial: "Dokument erstellen",
    noTutorialsFound: "Keine Dokumente gefunden",
    modal: {
      createTutorial: "Neues Dokument erstellen",
      tutorialType: "Dokumenttyp",
      typePdf: "PDF-Dokument",
      typeVideo: "Video-Dokument",
      tutorialName: "Dokumentname",
      tutorialNamePlaceholder: "Dokumentname eingeben",
      tutorialDescription: "Beschreibung",
      tutorialDescriptionPlaceholder: "Dokumentbeschreibung eingeben",
      videoUrl: "Video-URL",
      videoUrlPlaceholder: "https://example.com/video.mp4",
      videoUrlHelp:
        "Geben Sie eine gültige Video-URL ein (YouTube, Vimeo, etc.)",
      uploadPdf: "PDF-Datei hochladen",
      uploadFile: "Datei hochladen",
      orDragDrop: "oder hierher ziehen",
      pdfOnly: "Nur PDF-Dateien, bis zu 10MB",
      removeFile: "Datei entfernen",
      nameRequired: "Dokumentname ist erforderlich",
      descriptionRequired: "Beschreibung ist erforderlich",
      fileRequired: "PDF-Datei ist erforderlich",
      videoUrlRequired: "Video-URL ist erforderlich",
      invalidVideoUrl: "Bitte geben Sie eine gültige Video-URL ein",
      invalidFileType: "Bitte laden Sie nur eine PDF-Datei hoch",
      fileTooLarge: "Dateigröße muss weniger als 10MB betragen",
      tutorialCreatedSuccess: "Dokument erfolgreich erstellt!",
      tutorialCreatedError:
        "Fehler beim Erstellen des Dokuments. Bitte versuchen Sie es erneut.",
    },
    pdfViewer: {
      title: "PDF-Viewer",
      loading: "PDF wird geladen...",
      errorTitle: "Fehler beim Laden der PDF",
      errorMessage:
        "Die PDF-Datei konnte nicht geladen werden. Bitte versuchen Sie es erneut.",
    },
    defaultFileName: "dokument.pdf",
    folders: {
      root: "Alle Dokumente",
      folderLabel: "Ordner",
      emptyFolder: "Dieser Ordner ist leer.",
    },
  },
};

export default locale;
